import { Injectable } from '@angular/core';
import { Scorecard } from './models/scorecard.model';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

export interface ScorecardState extends EntityState<Scorecard> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'scorecard', idKey: 'ScorecardId' })
export class ScorecardStore extends EntityStore<ScorecardState> {
  constructor() {
    super();
  }
}
